import React, { useEffect, useState } from 'react';
import api, { formatApiError } from '../../lib/api';

const STATUSES = ['pending', 'confirmed', 'delivered', 'cancelled'];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(null);
  const [filter, setFilter] = useState('');
  const [err, setErr] = useState('');

  const load = () => {
    setLoading(true);
    api.get('/admin/orders').then(r => setOrders(r.data)).catch(e => setErr(formatApiError(e))).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    setBusy(id); setErr('');
    try {
      await api.patch(`/admin/orders/${id}`, { status });
      setOrders(os => os.map(o => o.id === id ? { ...o, status } : o));
    } catch (e) { setErr(formatApiError(e)); } finally { setBusy(null); }
  };

  const filtered = orders.filter(o => !filter || o.status === filter);

  return (
    <div>
      <div className="admin-page-head">
        <div>
          <h1>Orders</h1>
          <p className="muted">{orders.length} total · {filtered.length} shown</p>
        </div>
      </div>

      <div className="admin-toolbar">
        <select value={filter} onChange={e => setFilter(e.target.value)} className="admin-select" data-testid="orders-status-filter">
          <option value="">All statuses</option>
          {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <button onClick={load} className="btn btn-ghost" data-testid="orders-refresh-btn"><i className="fa-solid fa-rotate"></i><span>Refresh</span></button>
      </div>

      {err && <div className="form-error" style={{ marginBottom: 16 }}>{err}</div>}

      <div className="admin-table-wrap">
        <table className="admin-table" data-testid="admin-orders-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Customer</th>
              <th>Items</th>
              <th>Total</th>
              <th>Payment</th>
              <th>Status</th>
              <th>Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr><td colSpan={8}><div className="skeleton" style={{ height: 30 }} /></td></tr>
            )}
            {!loading && filtered.length === 0 && (
              <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: 'var(--muted)' }}>No orders</td></tr>
            )}
            {!loading && filtered.map(o => (
              <tr key={o.id} data-testid={`order-row-${o.id}`}>
                <td><strong>#{o.id.slice(0, 8).toUpperCase()}</strong></td>
                <td>
                  <div><strong>{o.customer_name || '—'}</strong></div>
                  <div className="muted" style={{ fontSize: 12 }}>{o.customer_email || ''}</div>
                  <div className="muted" style={{ fontSize: 12 }}>{o.customer_phone || ''}</div>
                </td>
                <td style={{ fontSize: 13 }}>
                  {(o.items || []).map((it, i) => (
                    <div key={i}>{it.qty}× {it.brand} {it.model}</div>
                  ))}
                </td>
                <td><strong>${Number(o.total).toFixed(2)}</strong></td>
                <td>
                  <span className={`stock-pill ${o.payment_status === 'paid' ? 'in' : 'out'}`}>
                    {o.payment_status}
                  </span>
                </td>
                <td>
                  <select
                    value={o.status}
                    onChange={e => updateStatus(o.id, e.target.value)}
                    disabled={busy === o.id}
                    className="admin-select"
                    data-testid={`order-status-${o.id}`}
                  >
                    {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="muted" style={{ fontSize: 12 }}>{new Date(o.created_at).toLocaleString()}</td>
                <td>{o.session_id && <span className="muted" style={{ fontSize: 11 }} title={o.session_id}><i className="fa-brands fa-stripe"></i></span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
